import { FeedbackConfigEnum } from "../models/FeedbackConfigEnum";
import { FeedbackTypesEnum } from "../models/FeedbackTypesEnum";
import { RetryConditionsEnum } from "../models/RetryConditionsEnum";
import { MAX_RETRIES } from "./Questionnaire/QuestionnaireViewer";
import { questionsTypes } from "./Questionnaire/questionsType";


export const getQuestionConfig = (question) => {
    let statusObject = {};
    let questionType = "";
    const isSurvey = question.data.survey;
    if (question.type === "options") {
        questionType = question.data.multiple ? "multiChoise" : "oneChoise"
    }
    if (question.type === "text") {
        questionType = question.data.longAnswer ? "openText" : "closedText"
    }
    statusObject = { ...questionsTypes[question.type][questionType][isSurvey ? "survey" : "regular"] }
    return statusObject
}

export const shouldCompleted = (question, maxRetries) => {
    let completed = false;
    if (question.submission) {
        if (!question.statusObject.enableRetries) {
            return true;
        }
        switch (question.statusObject.retryConditions) {
            case RetryConditionsEnum.OverAttempts:
                completed = question.submission.attempts >= maxRetries || question.submission.success;
                break;
            case RetryConditionsEnum.UntilCheck:
                completed = question.submission.success !== null ? true : false;
                break;
            case RetryConditionsEnum.AlwaysAllowRetries:
                completed = false;
                break;
        }
    }
    return completed
}

export const shouldFeedbackType = (question, maxRetries) => {
    let showFeedback = false, feedbackType = null;
    if (question.submission) {
        showFeedback = true
        if (question.submission.success !== null)
            switch (question.statusObject.feedbackStatus.feedbackAfterScore) {
                case FeedbackConfigEnum.CheckedCorrect:
                    feedbackType = question.submission.attempts >= maxRetries
                        ? question.submission.success ? FeedbackTypesEnum.Correct : FeedbackTypesEnum.MaxRetries
                        : question.submission.success ? FeedbackTypesEnum.Correct : FeedbackTypesEnum.InCorrect;
                    break;
                case FeedbackConfigEnum.Accepted:
                    feedbackType = FeedbackTypesEnum.Accepted;
                    break;
            }
        else {
            switch (question.statusObject.feedbackStatus.feedbackBeforeScore) {
                case FeedbackConfigEnum.Accepted:
                    feedbackType = FeedbackTypesEnum.Accepted;
                    break;
                case FeedbackConfigEnum.CheckedCorrect:
                    break;
            }
        }
    }
    return { type: feedbackType, show: showFeedback };
}

export const shouldShowSendButton = (questions) => {
    let showButton = false
    questions.map(q => {
        if (!q.completed && !q.statusObject?.autoSend)
            showButton = true
    })
    return showButton
}

export const calculateScore = (correct, attempts, retryConditions, scoreByRetries, points) => {
    if (correct) {
        if (retryConditions === RetryConditionsEnum.OverAttempts) {
            const scoreObj = scoreByRetries?.find(score => score.Attempts === attempts + 1)
            return scoreObj ? scoreObj.Score * points : points
        }
        else {
            return points
        }
    }
    return 0
}

export const shouldSendWithSendBTN = (question) => {
    return !question.completed
        && !question.statusObject.autoSend
        && question.ansData?.solution
        && question.changed
}

export const shouldAutoChangeContent = (questions) => {
    let changeContent = false;
    if (questions.every(q => q.completed ||( 
        q.data?.longAnswer && q.submission?.solution && q.submission?.attempts === 0 && !q.changed)))
        changeContent = true
    return changeContent
}

export const mergeData = (questions, submissions)=>{
    if (questions) {
        const mergedQuestions = questions.map((q, index) => {
            const submission = submissions?.find(x => x.assessmentExternalId === q.id) || q.submission;
            const updatedQuestion = { ...q }
            updatedQuestion.submission = submission;
            updatedQuestion.changed = q.changed || false;
            
            updatedQuestion.statusObject = getQuestionConfig(updatedQuestion);
            updatedQuestion.completed = shouldCompleted(updatedQuestion, MAX_RETRIES);
            updatedQuestion.feedback = q.changed ? q.feedback:  shouldFeedbackType(updatedQuestion, MAX_RETRIES);

            return updatedQuestion;
        });
        return mergedQuestions
    }
}